export const actionTypes = {
  DEPLOY_SIDEBAR: 'app/DEPLOY_SIDEBAR',
  DOCK_SIDEBAR: 'app/DOCK_SIDEBAR',
}

export const actions = {
  dockSidebar: () => dispatch => dispatch({ type: actionTypes.DOCK_SIDEBAR }),

  deploySidebar: () => dispatch =>
    dispatch({ type: actionTypes.DEPLOY_SIDEBAR }),

  navigate: path => dispatch => dispatch({ type: actionTypes.DOCK_SIDEBAR }),
}
